import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit } from '@angular/core';
import { AnalyticsService, CertificateListService, NotificationService, WalletService, NotificationKeys, Services } from '@core';
import { CurrencyPipe } from '@angular/common';
import { NzModalRef, NzModalService } from 'ng-zorro-antd/modal';
import { pageRoutes } from 'src/app/core/config/page-routes.config';

@Component({
    selector: 'app-exam-number',
    templateUrl: './exam-number.component.html',
    styleUrls: ['./exam-number.component.less'],
    standalone: false
})
export class ExamNumberComponent implements OnInit {

    created_at:string = "";
    surname: string = "";
    firstname:string =  "";
    middlename:string =  "";
    candidate_number:string =  "";
    year:string =  "";
    period:string =  "";
    exam_name: string = "";
    candidate_details: any;
    paymentModal: boolean = false;
    currency_unit_rate: any;
	  payment_currency: any;
    loading: boolean = false;
    retrievalCost?: number;
    chargeNotificationModal?: NzModalRef;
    walletCreditModal: boolean = false;
    candate_retrieve_id: any;
    notificationKeys = NotificationKeys;

  constructor(private router: Router, 
    private wallet: WalletService,
    private certificateService: CertificateListService,
    private currencyPipe: CurrencyPipe,
    private modal: NzModalService,
    private route: ActivatedRoute,
    private notify: NotificationService,
    private analytics: AnalyticsService,
    ) {}

  ngOnInit(): void {
    this.candidate_details = this.getRetreivedCandidateInformation();
    this.candate_retrieve_id = this.candidate_details.id;
    this.surname = this.candidate_details.surname;
    this.firstname = this.candidate_details.firstname;
    this.exam_name = this.candidate_details.exam_name;
    this.year = this.candidate_details.exam_year;
    this.candidate_number = this.candidate_details.candidate_number;
    // this.confirmPayment();
    
  }

  getCurrencyUnitRate() {
		let userObject = JSON.parse(localStorage.getItem('_token')!);
		this.currency_unit_rate = userObject.wallet.currency_unit_rate;
		this.payment_currency = userObject.wallet.payment_currency;
    this.getServiceCost();
	}

  getServiceCost() {
    this.wallet
      .walletServices()
      .then((res) => {
        let services = res?.data?.data.filter(
          (i: any) => i.item?.toLowerCase() == "exam_number_retrieval"
        )[0];
        this.retrievalCost = services?.service_values?.filter(
          (i: any) => i.value_text?.toLowerCase() == "unit"
        )[0]?.value;
        this.chargesNotification();
      })
      .catch((err) => {
        console.warn(err);
      });
  }

  cancelPaymentOptionsModal() {
		this.paymentModal = false;
	}
	
	cancelmodalContentbillingpayment() {
		this.walletCreditModal = false;
	}

  initiateFundingWallet(value: any) {
		location.assign(value);
		this.walletCreditModal = false;
	}

  chargesNotification(): void {
    this.chargeNotificationModal = this.modal.confirm({
      nzTitle: "Recover Candidate Number",
      nzContent: `You will be charged <b>${this.retrievalCost} units (${this.currencyPipe.transform(this.currency_unit_rate*this.retrievalCost!, this.payment_currency, 'symbol')}) </b> for a successful Recovery of your candidate number and the applicable charges that will be deducted are non-refundable. Do you <br> wish to continue?`,
      nzOnOk: () => this.paymentModal = true,
      nzCancelText: "Cancel",
      nzOkText: "Yes",
      nzOnCancel: () => {
        console.warn(null)
      },
    });
  }

  confirmPayment() {
		let processor = null;
		let reference = null;
		this.route.queryParams.subscribe(params => {
			processor = params?.processor;
			reference = params?.reference;
			if (!processor && !reference) {
        if(this.candidate_details?.wallet_history_id == null)
        {
          this.getCurrencyUnitRate()
         // this.chargeRetrievals()
        }
				return;
			}
			if (processor == "flutterwave" && params?.status != "successful") {
				this.analytics.transactionCompleted('failed', Services.EXAM_NUMBER_RETRIEVAL);
				this.notify.error(
					"",
					"Your payment transaction was " + params.status + "!",
					"billing",
				);
				this.router.navigateByUrl(this.router.url.split("?")[0]);
				return;
			}
			let body = {
				processor: processor,
				trxref: reference,
				reference: reference,
				transaction_id: params?.transaction_id ? params?.transaction_id : params?.tx_ref,
			};
			this.certificateService
				.confirmPayment(body)
				.then(res => {
					this.loading = false;
					if (res.status === "FAILED") {
						this.analytics.transactionCompleted('failed', Services.EXAM_NUMBER_RETRIEVAL);
						this.notify.error("", res.message, "billing");
						this.router.navigateByUrl(this.router.url.split("?")[0]);
						return;
					}
          this.analytics.transactionCompleted('success', Services.EXAM_NUMBER_RETRIEVAL);
          this.router.navigateByUrl(this.router.url.split("?")[0]);
          this.chargeRetrievals()
				})
				.catch(err => {
					console.warn(err);
				});
		});
	}

  initiateWallet(value: any) {
		if (value == "WALLET") {
			this.paymentModal = false;
      this.chargeRetrievals();
		} else {
			location.assign(value);
		}
	}

  chargeRetrievals(){
    this.certificateService.confirmCandidateNumberRetrievalCharge(this.candate_retrieve_id).subscribe(
      (res) => {
        this.loading = false;
        if (res.status == "FAILED") {
          this.notify.error("", res.message, this.notificationKeys.CERTIFICATE);
        }

        this.certificateService.getExamNoRetrievals().then(res=> {
          if(res.status == "FAILED"){
            this.notify.error("", res.message, this.notificationKeys.CERTIFICATE);
          }
          let obj = res?.data.filter((i: any) => i.id == this.candate_retrieve_id)[0]
          this.candidate_details.candidate_number = obj.candidate_number
          this.candidate_number = obj.candidate_number
       })
       this.notify.success('', 'Payment confirmed successfully!', 'retrieve')
      },
      async (err: any) => {
        if (err.status === 402 && err?.error?.data == "04") {
          setTimeout(() => {
            this.walletCreditModal = true;
          }, 1000);
        }
        else {
          this.getCurrencyUnitRate()
        }
        this.notify.error("", err?.error?.message, this.notificationKeys.CERTIFICATE);
        this.loading = false;
      }
    );
  }

  getRetreivedCandidateInformation() {
    let result: any = localStorage.getItem("retrieved");
    return result ? JSON.parse(result) : {};
  }

  backToAccess() {
    this.router.navigate([pageRoutes.access.accessing]);
  }

}
